/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import Helpers from "util/helpers";
import "components/widgets/training/Training.css";

class TrainingScore extends Component {
  state = {
    showingChildren: false,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };
  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 3:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-tv ">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv"></span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class "></span>
          </td>
        );
    }
  };

  renderScoreChart = (t) => {
    // console.log(t);
    // if (t.score === null) return null;
    // let color = "red";
    // if (51 <= t.score && t.score < 76) color = "orange";
    // if (t.score >= 76) color = "green";
    let color = t.success ? "green" : "red";

    return (
      <>
        <div
          id="statusCalendarChart_1"
          className="statusCalendarChart"
          data-percent={t.score}
        >
          <div>
            <div className="single-chart">
              <svg viewBox="-2 -2 40 40" className={`circular-chart ${color}`}>
                <path
                  className="circle-bg"
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <path
                  className="circle"
                  strokeDasharray={`${t.score}, 100`}
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <text x="18" y="22.35" className="percentage">
                  {t.score}
                </text>
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="5">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10117</Trans>
                  </div>
                </td>
                <td className="showGrup">{Helpers.renderDate(t.startDate)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10118</Trans>
                  </div>
                </td>
                <td className="showGrup">{Helpers.renderDate(t.endDate)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Puan">10177</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderScoreChart(t)}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">{t.training.name}</td>
            <td className="showGrup">{Helpers.renderDate(t.startDate)}</td>
            <td className="showGrup">{Helpers.renderDate(t.endDate)}</td>
            <td className="showGrup">{this.renderScoreChart(t)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.ToggleChildren}>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">{t.training.name}</td>
          </tr>
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

export default TrainingScore;
